export interface ErrorResponse extends Response {
  ok: false;
}

export const isErrorResponse = <TData = unknown>(response: Response | TData): response is ErrorResponse => {
  return typeof response === 'object' && response !== null && 'ok' in response && !response.ok;
};

interface UnauthorizedErrorResponse extends ErrorResponse {
  status: 401;
}

export const isUnauthorizedErrorResponse = <TData = unknown>(
  response: Response | TData,
): response is UnauthorizedErrorResponse => {
  return isErrorResponse(response) && response.status === 401;
};

export interface ValidationErrorResponse extends ErrorResponse {
  details?: Record<string, string[]>;
}
export const isValidationErrorResponse = <TData = unknown>(
  response: Response | TData,
): response is ValidationErrorResponse => {
  return isErrorResponse(response) && 'statusText' in response && response.statusText === 'Validation failed';
};
